import { dayjs } from 'src/services/date';

/**
 * Returns the subscription with the closest period end out of all dunning subscriptions.
 *
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 */
export function closestDunningSub(state) {
  /** @type {import('dayjs').Dayjs | null} */
  let closestPeriodEnd = null;
  /** @type {import('src/types/subscription-store').SubscriptionData | null} */
  let closestSubscription = null;

  state.subscriptions.forEach((subscription) => {
    const { currentPeriodEndsAt, status } = subscription;

    if (status !== 'dunning') {
      return;
    }

    const subscriptionPeriod = dayjs(currentPeriodEndsAt);
    if (closestPeriodEnd === null || dayjs(currentPeriodEndsAt).isBefore(closestPeriodEnd)) {
      closestPeriodEnd = subscriptionPeriod;
      closestSubscription = subscription;
    }
  });

  return closestSubscription;
}
